// eslint-disable-next-line import/no-cycle
import { ULID } from '.';

enum type {
	'business',
	'individual'
}

export interface Customer {
	id?: ULID;
	type: type;
	name: string;
	email: string;
	phoneNumber: string;
	logo: string;
	business: {
		vat: string;
	};
	color: {
		primary: string;
		secondary: string;
		tertiary: string;
	};
	readonly items: {
		total: {
			scans: number;
			qrCodes: number;
			storage: number;
			users: number;
		};
		used: {
			scans: number;
			qrCodes: number;
			storage: number;
			users: number;
		};
	};

	invoiceSettings: {
		footer: string;
	};

	readonly createdAt?: Date;
	readonly updatedAt?: Date;
	readonly deletedAt?: Date;
}

export interface CustomerFormEdit {
	id: ULID;
	name: string;
	email: string;
	type: CustomerType;
	phoneNumber: string;
	vat: string;

	invoiceSettings: {
		footer: string;
	};
}

export interface CustomerActivateForm {
	planId: ULID;
}

export enum CustomerType {
	CONSUMER = 'consumer',
	BUSINESS = 'business',
	NONE = 'none'
}
